import React from 'react';
import '../styles/AboutUs.css';
import { Breadcrumb } from 'semantic-ui-react';
import Timeline from '../assets/timeline.png'



const breadcrumbSections = [
    { key: 'home', content: 'HOME', href: "/" },
    { key: 'about us', content: 'ABOUT US', active: true },
]

function AboutUs() {

    return (
        <>
            <div style={{ textAlign: 'left', marginLeft: '70px', marginTop: '80px' }}>
                <Breadcrumb icon='right angle' sections={breadcrumbSections} style={{ backgroundColor: '#fff' }} />
            </div>


            <div className="fr-header">About Us</div>

            <div className="aboutus-container">
                <div className="timelineimage">
                    <img src={Timeline} alt="timeline" style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto', width: '-webkit-fill-available', maxWidth: '1500px' }} />
                </div>

                <div className="aboutus-text" style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto' }}>

                    <p>Titanium Transportation Group Inc. is a leading asset-based transportation and logistics company operating in Canada and the United States. Titanium Transportation Group Inc. was created by
                        Ted and Marilyn in 2002. Starting off in a small room with just brokered loads in the first week, Titanium Transportation Group Inc. was able to upgrade to larger headquarters
                        and purchased it’s first straight truck in just 2 years.Titanium Transportation Group Inc. has offices across Canada and
                        the United States, including Belleville, Bracebridge, Brantford, Charlotte, Chicago, Cornwall, Denver, Napanee, Nashville, North Bay, Windsor, and Atlanta.</p>

                    <p>Titanium Transportation Group Inc. now owns approximately 800 power units, 3000 trailers, 1100 employees, and independent owner operations and specializes in truckload,
                        cross-border  trucking services, freight logistics, and warehousing and distribution to over 1000 customers. Titanium Transportation Group Inc. has approximately 100,000 sq ft.
                        of warehouse space.</p>

                    <p>Titanium Transportation Group Inc. has made 12 asset-based trucking acquisitions since 2011 and is among the top 15 largest Canadian transportation companies. Titanium Transportation Group Inc.
                        is one of three transportation companies that is publicly traded in Canada. It has been ranked by Canadian Business as one of Canada’s Fastest Growing Companies for 12
                        consecutive years.</p>

                </div>
                < br />
                < br />
                < br />
            </div>
        </>
    )
}

export default AboutUs
